'use strict';
window.uomedia = window.uomedia || {};
var Cookies = Cookies || null;

(($) => {
  const $banner = $('.gdpr-banner');
  const $button = $banner.find('button');
  const cookieName = 'gdpr-banner';
  if (Cookies && Cookies.get(cookieName)) {
    $banner.hide();
  } else {
    $banner.show();
  }
  $button.on('click', function () {
    $banner.hide();
    if(Cookies) {
      Cookies.set(cookieName, true);
    }
  });

})(jQuery);
